import WbSunnyOutlinedIcon from '@mui/icons-material/WbSunnyOutlined';

/**
 * Fototipo de Fitzpatrick: cor da pele e reação ao sol, do tipo I ao VI.
 * Referência clínica: classificação dos fototipos da Sociedade Brasileira de
 * Dermatologia. Textos nossos; as cores são só uma amostra visual.
 *
 * Os valores precisam ser os mesmos de public/api/scales/catalog/fitzpatrick.php.
 */
const fitzpatrick = {
  key: 'fitzpatrick',
  name: 'Fototipo de Fitzpatrick',
  description: 'Tipo de pele pela reação ao sol, do I ao VI',
  details: 'Classifica a pele pela cor e pela forma como reage ao sol, do tipo I (muito clara, sempre queima) ao VI (negra, quase nunca queima). Ajuda a escolher procedimentos, parâmetros de laser e cuidados com manchas. Um clique marca o fototipo do atendimento, o card mostra o da última consulta e a aba Saúde guarda a evolução.',
  kind: 'single',
  icon: WbSunnyOutlinedIcon,
  accent: 'amber',
  options: [
    { value: 'I', label: 'Tipo I', caption: 'Muito clara', color: '#F7E1D3', help: 'Pele muito clara. Sempre queima e não bronzeia.' },
    { value: 'II', label: 'Tipo II', caption: 'Clara', color: '#EECBB0', help: 'Pele clara. Queima com facilidade e bronzeia pouco.' },
    { value: 'III', label: 'Tipo III', caption: 'Morena clara', color: '#D9A984', help: 'Pele morena clara. Às vezes queima e bronzeia aos poucos.' },
    { value: 'IV', label: 'Tipo IV', caption: 'Morena', color: '#B9835A', help: 'Pele morena. Queima pouco e bronzeia com facilidade.' },
    { value: 'V', label: 'Tipo V', caption: 'Morena escura', color: '#8A5634', help: 'Pele morena escura. Raramente queima e bronzeia bastante.' },
    { value: 'VI', label: 'Tipo VI', caption: 'Negra', color: '#4A2C1D', help: 'Pele negra. Quase nunca queima e tem pigmentação intensa.' },
  ],
};

export default fitzpatrick;
